import {
  Component, OnInit, Inject, ViewChild, TemplateRef, Input, Output, EventEmitter,
  AfterViewChecked, OnChanges, SimpleChanges, ElementRef, AfterViewInit
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView, DAYS_OF_WEEK, CalendarMonthViewDay } from 'angular-calendar';
import { LocalStorageService } from '../shared/services/localStorage.service';
import { EventoperationsService } from '../shared/services/eventoperations.service';
import { DvmpService } from '../shared/services/dvmp.service';
import { GlobalvaribleService } from '../services/globalvarible.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject, empty } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ModaldisclaimerComponent } from '../modaldisclaimer/modaldisclaimer.component';
import { TermsandconditionsComponent } from '../termsandconditions/termsandconditions.component';
import { PrePostMedicationDialogComponent } from '../pre-post-medication-dialog/pre-post-medication-dialog.component';
import * as moment from 'moment';
import * as momenttz from 'moment-timezone';
import { Moment } from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../shared/date-picker-format';
import { environment } from '../../environments/environment';
import { GeneratepdfService } from '../shared/services/generatepdf.service';
import {
  WeekDay,
  MonthViewDay
} from 'calendar-utils';
import * as _ from 'lodash';
import { Router } from '@angular/router';

declare var $: any;
const TREATMENT_DATE = 'Start treatment Date';
const premedication = $localize`:@@preInfusionText:[Placeholder for pre-infusion medication paragraph, as per SMPC]`;

const postmedication = $localize`:@@postInfusionText:[Placeholder for post-infusion medication paragraph as per SMPC]`;

const profiliaxisText = $localize`:@@profilaxisText:Profiliaxis text en`;


/**
 * Restriction are handled from the below constant
 * Create new constant key with drug first 4 character in lower case
 * Ex: Darzelax = darz
 *
 */
const restriction: any = {
  darz: {
    priortoCurrentDateValidation: true,
    priortoCurrentDateMsgDisplay: false,
    priortoCurrentDateMsg: 'prior to Current Date Msg',
    priortoNextEventValidation: true,
    priortoNextEventMsgDislay: false,
    priortoNextEventMsg: 'prior to Next Event Msg',
    priortoNextEventWarning: true,
    priortoNextEventWarningDays: 7,
    priortoNextEventWarningMsg: 'La nueva pauta de Darzalex no cumple según lo establecido en Ficha Técnica'
  },
  velc: {
    priortoCurrentDateValidation: true,
    priortoCurrentDateMsgDisplay: false,
    priortoCurrentDateMsg: 'prior to Current Date Msg',
    priortoNextEventValidation: true,
    priortoNextEventMsgDislay: false,
    priortoNextEventMsg: 'prior to Next Event Msg',
    priortoNextEventWarning: true,
    priortoNextEventWarningDays: 3,
    priortoNextEventWarningMsg: 'La nueva pauta de Velcade no cumple según lo establecido en Ficha Técnica'
  }
};

enum DrugLabels {
  melf = 'Melfalán 9 mg/m2',
  pred = 'Prednisona 60 mg/m2',
  dexa20 = 'Dexametasona 20 mg',
  lena = 'Lenalidomida 25 mg',
  dexa40 = 'Dexametasona 40 mg'
}

@Component({
  selector: 'app-calendar-details',
  templateUrl: './calendar-details.component.html',
  styleUrls: ['./calendar-details.component.css'],
  providers: [
    {
      provide: DateAdapter, useClass: AppDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
    }
  ]
})
export class CalendarDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild('warningContentModal', { static: true }) warningContentModal: TemplateRef<any>;
  @ViewChild('deletingContentModal', { static: true }) deletingContentModal: TemplateRef<any>;
  @ViewChild('nonbussinessday', { static: true }) nonbussinessday: TemplateRef<any>;
  @ViewChild('onetimeDragMsg', { static: true }) onetimeDragMsg: TemplateRef<any>;
  // onetimeDragMsg: NgbdModalConfirm;
  @ViewChild('WeekendModal', { static: true }) WeekendModal: TemplateRef<any>;
  @ViewChild('pretext') premedicationtext: ElementRef;
  @ViewChild('posttext') postmedicationtext: ElementRef;
  @ViewChild('profil') profiltext: ElementRef;
  @ViewChild('alertModal', { static: true }) alertModal: TemplateRef<any>;
  changedColor1: string;
  draggingStatus: boolean;
  modalInstance = true;
  pdfDisclaimerText = false;
  cloningEvents: any;
  cycledate: any;
  compdate: any;
  daydisplay: any;
  dragStartdate: Date;
  dragEndtdate: Date;
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  treatment = environment.treatment_date;
  dosesSubmit = false;
  dosesSubmit1 = true;
  toggleFilterEvents: any;
  warningMessage = '';
  TreatementSelection = '';
  Observations: string;
  Patientconfigs: JSON;
  injections: any;
  _numberofdays = 0;
  maxNumdays: number;
  _startDate: any;
  _endDate: any;
  datecycle: any = {};
  viewDate: Date[] = [];
  _pdetails: any;
  _localDefValues: any = [];
  _treatments = [];
  _eventStartDate: Date;
  _events: any = [];
  _cycles = [];
  filteredArr: any[];
  updatevent: any = [];
  _holidays: any;
  _pubHolidays: any;
  _events_availability = false;
  _postmedicationtext: string;
  _premedicationtext: string;
  daysWithoutHoliday: any;
  @Input() _dosetext: string;
  @Output() dosetextChange = new EventEmitter<string>();
  @Output() changeEvt = new EventEmitter<any>();
  _weight: number;
  _height: number;
  _dose: any = [];
  _vails20ml: any = [];
  _vails5ml: any = [];
  treatlabels = [];
  treatlabelsdiplay = [];
  treatoptions = [];
  treatmentfullname: string;
  adminstration: any = [];
  is_pdfloadinng = false;
  _loaderflag = false;
  printedstarted: Date;
  toggle = true;
  selecteddrugcolor: String;
  selecteddrugname: String;
  selectEvent: Object;
  diffDays: Number;
  cssclassname = 'far fa-file-pdf';
  Editevent: FormGroup;
  presentmonth: any;
  condition = false;
  inputvalues;
  count = 0;
  status = true;
  modalsfalg = [];
  modalCount = 0;
  prepostMedicationCount = 0;
  modalCollapse;
  prepostMedication = false;
  modalCountMelfalan = 0;
  modalCountDexametasona = 0;
  modalCountvalcade = 0;
  prepostsCount = 0;
  prePostCount = 0;
  changedColor = false;
  _termsconditionFlag = true;
  _errorflag = false;
  _colorToggle = false;
  dexametasonaColor = '';
  cancelPreText = true;
  cancelPostText = true;
  cancelProfilText = true;
  cycleStartDays: any;
  viewDate1: Date = new Date();
  debug = true;
  lastrecord: any;
  splitDoseCheck: string;
  month_display: boolean;
  eventSelectedDate: Date;
  locale: string;
  DateArr: Array<Date> = [];
  /**Array of color scheme */
  colorArray = [];
  melfMaxValue: any;
  predMaxValue: any;
  velcMaxValue: any;
  velcMinValue: any;

  // _colors: any = {
  //   'Darzalex ®': {
  //     primary: '#009999',
  //     secondary: '#FAE3E3',
  //     icon: 'assets/images/legends/Darzalex ®.png'
  //   },
  //   'Velcade ®': {
  //     primary: '#9933ff',
  //     secondary: '#FAE3E3',
  //     icon: 'assets/images/legends/valcade.png'
  //   },
  //   'Melfalán': {
  //     primary: '#ed7d31',
  //     secondary: '#FAE3E3',
  //     icon: 'assets/images/legends/lenda.png'
  //   },
  //   'Prednisona': {
  //     primary: '#ed7d31',
  //     secondary: '#FAE3E3',
  //     icon: 'assets/images/legends/lenda.png'
  //   },
  //   'meltilprednisolona': {
  //     primary: '#ABABAB',
  //     secondary: '#FAE3E3',
  //     icon: 'assets/images/legends/lenda.png'
  //   },

  //   'dexametasona': {
  //     primary: '#ed7d31',
  //     secondary: '#009999',
  //     icon: 'assets/images/legends/lenda.png'
  //   },
  //   'lenalidomida': {
  //     primary: '#ed7d31',
  //     secondary: '#cccccc',
  //     icon: 'assets/images/legends/lenda.png'
  //   },
  //   'Intravenosa': {
  //     primary: '#009999',
  //     secondary: '#FAE3E3',
  //   },
  //   'Subcutánea': {
  //     primary: '#9933ff',
  //     secondary: '#FAE3E3',

  //   }, 'Oral': {
  //     primary: '#ed7d31',
  //     secondary: '#FAE3E3',
  //   }
  // };
  element: HTMLElement;
  refresh: Subject<any> = new Subject();
  dosage_8mg = false;
  days: any;
  saveAndCancel1 = true;
  saveAndCancel2 = true;
  saveAndCancel3 = true;
  totalEvents: any[];
  cycleTrueCount: number;
  cycleFalseCount: number;
  testArr = [];
  _colors: any = {};
  drugs: any = [];

  // public specialPopulation() { /***ADOJ-1 */
  //   var modal = document.getElementById("specialPopulation");
  //   modal.style.display = "block";
  // }

  public closespecialPopulation() {
    const modal = document.getElementById('specialPopulation');
    modal.style.display = 'none';
  }
  iphoneDeteact() {
    const iDevices = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ];

    if (!!navigator.platform) {
      while (iDevices.length) {
        if (navigator.platform === iDevices.pop()) { return true; }
      }
    }

    return false;
  }

  public generatePDF() {
    this.pdfGen.generatePdfFile();
  }

  constructor(
    public dialog: MatDialog,
    public formbuilder: FormBuilder,
    public _localstorage: LocalStorageService,
    public _dvmp: DvmpService,
    public _globalvarible: GlobalvaribleService,
    @Inject(DOCUMENT) private document: any,
    public modal: NgbModal,
    public dateadapter: DateAdapter<any>,
    public pdfGen: GeneratepdfService,
    public eventOperations: EventoperationsService,
    private router: Router
  ) {
    console.log(this._dvmp.treatsArray);
    if (this._dvmp.treatsArray.length === 0) {
      this.router.navigate(['/']);
    } else {
      this._colors = this._dvmp.colors;
      this.locale = this._dvmp.calLangCode;
      this._pdetails = JSON.parse(this._localstorage.getItem('patientdetails'));
      this._numberofdays = this._pdetails.Nocicle;
      this._localDefValues = JSON.parse(this._localstorage.getItem('DeafultValues')).sort((n1, n2) => n1.cycle - n2.cycle);
      this.maxNumdays = this.maximumNumberofDays() * this._numberofdays;

      // if (this._pdetails.Tratamientos == 'DVmp') {
      //   this._treatments = [
      //     { value:  $localize`:@@Darzalex:Darzalex ®`},
      //     { value:  $localize`:@@Velcade:Velcade ®`},
      //     { value:  $localize`:@@Melfalán:Melfalán`},
      //     { value:  $localize`:@@Prednisona:Prednisona`}];
      // } else if (this._pdetails.Tratamientos == 'DVd') {
      //   this._treatments = [
      //     { value:  $localize`:@@Darzalex:Darzalex ®`},
      //     { value:  $localize`:@@Velcade:Velcade ®`},
      //     { value:  $localize`:@@dexametasona:dexametasona`}];
      // } else if (this._pdetails.Tratamientos == 'DRd') {
      //   this._treatments = [
      //     { value:  $localize`:@@Darzalex:Darzalex ®`},
      //     { value:  $localize`:@@lenalidomida:lenalidomida`},
      //     { value:  $localize`:@@dexametasona:dexametasona`}];
      // } else {
      //   this._treatments = [{ value:  $localize`:@@Darzalex:Darzalex ®`}];
      // }
      this._treatments = this._dvmp.treatsArray;
      this.drugs = this._dvmp.drugs;
      if (this._dvmp.holidays.length === 0) {
        alert('could not load holidays !');
      }
    }
  }


  ngOnInit() {
    // this._colors = this._dvmp.colors;
    this.dateadapter.getFirstDayOfWeek = () => 1;
    localStorage.setItem('pretextvalue', premedication);
    localStorage.setItem('dexa40', '');
    localStorage.setItem('lena', '');
    localStorage.setItem('drugZero', '');
    this.Observations = JSON.parse(this._localstorage.getItem('patientdetails')).observations;
    this.TreatementSelection = JSON.parse(this._localstorage.getItem('patientdetails')).Tratamientos;
    this._weight = this._pdetails.Wieght;
    this._height = this._pdetails.Hieght;
    this.splitDoseCheck = JSON.parse(this._localstorage.getItem('DoseDivide'));
    localStorage.setItem('flag', 'true');
    this.settingPanel();
    this.printedstarted = new Date(this._pdetails.Fechaactual);
    this._startDate = new Date(this._pdetails.Fechaactual);
    console.log(this._startDate);
    this._eventStartDate = this._startDate;
    this._localDefValues = JSON.parse(this._localstorage.getItem('DeafultValues')).sort((n1, n2) => n1.cycle - n2.cycle);
    const totaldays = this._dvmp.GetTotalNumberOfDays(this._localDefValues);
    this._endDate = this.getEndDate(totaldays);
    this._dvmp.setEnddate(this._endDate);
    console.log(this._endDate);
    this.viewDate = this.monthDiff();
    const monthDiff = momenttz(this._endDate).diff(momenttz(this._startDate), 'months') + 1;
    // this.getNumberOfMonths(this._startDate, monthDiff);

    let maxday = 0;
    const maxcycle = [];

    for (const defV in this._localDefValues) {
      let max = 0;
      const maxcyleday = [];
      this._eventStartDate = this.getNewDate(maxday);

      const cycle_days = [];
      let k = 0;
      const ccycle = this._localDefValues[defV].cycle;


      const falg = true;
      let eventflag = false;
      for (const jsc in this._localDefValues[defV].default) {
        let eventTitle = this._treatments[k].value;
        this.days = this._localDefValues[defV].default[jsc].split('(');
        if (this.days) {
          this.days = this.days[0].trim();
          this.days = this.days.split(',').map(function (item) {
            return parseInt(item, 10);
          });

        }

        const maxdayarray = this._localDefValues[defV].default[jsc].split('(');
        if (maxdayarray[0]) {
          const maxdaystring = maxdayarray[1];
          const maxdaysvalue = maxdaystring.split(' ');
          const maxcyclestring = parseInt(maxdaysvalue[0], 10);
          maxcyleday.push(maxcyclestring);
          const length = this._localDefValues[defV].default.length - 1;
          const maxm1 = _.maxBy(maxcyleday);
          if (falg) {
            // var maxm = _.maxBy(maxcyleday);
            // var max_of_array = Math.max.apply(Math, maxcyleday);
            this.days.push(maxm1);
            // falg = false;
            eventflag = true;
          }
        }
        cycle_days.push(this.days);
        for (const i in this.days) {
          if (parseInt(i, 10) === this.days.length - 1 && eventflag) {
            eventTitle = '';
            eventflag = false;
          }
          this.cycleStartDays = this.days[i] === 1 ? true : false;

          if (!isNaN(this.days[i])) {

            const uuid = ccycle + eventTitle.toString().substring(0, 4) + (this.days[i] - 1);
            // console.log(uuid);

            const offsetdate = moment(this._eventStartDate).utcOffset();
            const dt = momenttz(this._eventStartDate, 'YYYY-DD-MM', true).utcOffset(offsetdate).add(this.days[i] - 1, 'days')
              .format().substring(0, 10);

            const ev = {
              start: new Date(dt),
              enddate: new Date(dt),
              title: eventTitle,
              color: eventTitle ? this._colors[eventTitle].primary : 'transparent',
              // draggable: eventTitle === "Darzalex ®" || eventTitle === "Velcade ®" ? true : false,
              draggable: this._dvmp.DragnDropWithPopup,
              eventStart: this.cycleStartDays,
              cycle: ccycle,
              type: 'legends',
              block: false,
              cycledate: this._eventStartDate,
              id: this._eventStartDate,
              uuid: uuid,
              dragend: new Date(dt),
              resizable: {
                beforeStart: true,
                afterEnd: true
              },
              last: false
            };

            const ev1 = {
              start: new Date(dt),
              enddate: new Date(dt),
              title: eventTitle,
              color: eventTitle ? this._colors[eventTitle].primary : 'transparent',
              // draggable: eventTitle === "Darzalex ®" || eventTitle === "Velcade ®" ? true : false,
              draggable: false,
              eventStart: this.cycleStartDays,
              cycle: ccycle,
              type: 'cycle',
              cycledate: this._eventStartDate,
              id: this._eventStartDate,
              dragend: new Date(dt),
            };

            if (this._pdetails.Formulation !== null && ev['title'] === 'Darzalex ®' && this._pdetails.Formulation === 'SC') {
              ev['color'] = this._colors.Subcutaneous.primary;
            }

            if (this.dosage_8mg === true) {
              this._events.push(ev);
              this._cycles.push(ev1);
              this._events.map((item, index) => {
                const uid = item.uuid.substring(0, 6);
                if (index < 2) {
                  item.title = '*Darzalex ®';
                }
                // if(index === 1){
                //   item.draggable = false;
                // }
              });
            } else {

              this._events.push(ev);
              this._cycles.push(ev1);
              // this._events.map((item, index) => {
              //   let uid = item.uuid.substring(0,6);

              // });

            }

          }
        }
        k++;
      }








      const MaxRow = cycle_days.map(function (row) {
        return Math.max.apply(Math, row);
      });
      for (let i = 0; i < MaxRow.length; i++) {

        if (isNaN(MaxRow[i])) {
          MaxRow[i] = 0;
        }
      }
      max = Math.max.apply(null, MaxRow);
      maxday = maxday + max;
    }

    this._endDate = maxcycle[maxcycle.length - 1];
    if (this._dvmp.holidays.length > 0) {
      for (const hdays of this._dvmp.holidays) {
        const days = hdays.date.iso;
        const hodaydesc = hdays.name.length > 12 ? hdays.name.substring(0, 12) + '...' : hdays.name;
        const holiday = {
          cycle: null,
          start: new Date(days),
          eventStart: null,
          uuid: 'holiday',
          //  enddate: new Date(this._endDate),
          title: hodaydesc,
          fullname: hdays.name,
          color: 'red',
          icon: 'assets/images/holiday.png',
          type: 'holiday',
          resizable: {
            beforeStart: true,
            afterEnd: true
          },
          last: false
        };

        // console.log("diff events", this._events);
        this._events.push(holiday);
      }
    }
    this.totalEvents = [...this._events, ...this._cycles];
    // console.log("diff==events", this.totalEvents);

    // console.log("diff events", this._events);

    // this.totalEvents.sort(this.predicateBy("start"));
    this.cloningEvents = _.clone(this.totalEvents);
    this._globalvarible.setDefaultEvents(this.totalEvents);
    // console.log("Total events are", this.totalEvents);
    this.month_display = this.isEventsExists();
    console.log('month dispay )))))))))))))))))))))', this.month_display);
    this._events_availability = true;
    // this._events[this._events.length - 1].last = true;
    // this._globalvarible.setLastEvent(this._events[this._events.length - 1]);

    this.Editevent = this.formbuilder.group({
      Editapplyby: [{ disable: true }, Validators.required],
      Ciclocheck: [, Validators.required],
      Ciclocolorcheck: [, Validators.required],
      Fechaactual: [new Date(), Validators.required],
    });

    const inputclick = document.getElementsByClassName('inputclickAccept');
    for (let i = 0; i < inputclick.length; i++) {
      this.modalsfalg.push(true);
    }


    this.daysWithoutHoliday = this._events.filter(x => {
      return x.type !== 'holiday' && (x.title === 'Velcade ®' || x.title === 'Darzalex ®');
    });
    const uniqueArr = (new Set(this.daysWithoutHoliday.map((d) => d.start.getTime())));
    uniqueArr.forEach(un => {
      this.checkOnDates((un));
    });

  }


  checkOnDates(date) {
    this._events.forEach(evs => {
      if (evs.start.getTime() === date) {
        evs.block = true;
      }
    });
  }
  // onetimeDragMsgAccepted(modal){
  //   console.log(modal);
  //   modal.close(true);
  // }
  drugChanges($event) {

    switch (this.TreatementSelection) {
      case 'DVmp':
        this.toggleFilterEvents = {
          treatment: this.TreatementSelection,
          melf: this._dose[DrugLabels.melf],
          pred: this._dose[DrugLabels.pred]
        };
        if (this.toggleFilterEvents.melf === 0 && this.toggleFilterEvents.pred === undefined) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'Melfalán');
        } else if (this.toggleFilterEvents.pred === 0 && this.toggleFilterEvents.melf === undefined) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'Prednisona');
        } else if (this.toggleFilterEvents.pred === 0 && this.toggleFilterEvents.melf === 0) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'Prednisona' && item.title !== 'Melfalán');
        } else if (this.toggleFilterEvents.pred > 0 && this.toggleFilterEvents.melf === 0) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'Melfalán');
        } else if (this.toggleFilterEvents.pred === 0 && this.toggleFilterEvents.melf > 0) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'Prednisona');
        } else {
          this.totalEvents = this._globalvarible.getDefaultEvents();
          console.log('total events in dvmp=', this.totalEvents);
        }

        break;
      case 'DVd':
        this.toggleFilterEvents = {
          treatment: this.TreatementSelection,
          dexa20: this._dose[DrugLabels.dexa20]
        };
        if (this.toggleFilterEvents.dexa20 === 0) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'dexametasona');
        } else {
          this.totalEvents = this._globalvarible.getDefaultEvents();
        }
        break;
      case 'DRd':


        this._globalvarible.getSelectValue();
        console.log('input-lena and dexa value=', this._globalvarible.getSelectValue(), '---', $event.target.value, '------');
        const dexaVal = parseFloat($event.target.value);
        this._globalvarible.setInputValue(dexaVal);
        if (dexaVal === 0 && this._globalvarible.getSelectValue() === undefined) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'dexametasona');
        } else if (dexaVal > 0 && this._globalvarible.getSelectValue() === 0) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'lenalidomida');
        } else if (dexaVal === 0 && this._globalvarible.getSelectValue() > 0) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'dexametasona');
        } else if (dexaVal === 0 && this._globalvarible.getSelectValue() === 0) {
          this.totalEvents = this.cloningEvents.filter(item => item.title !== 'dexametasona' && item.title !== 'lenalidomida');
        } else {
          this.totalEvents = this._globalvarible.getDefaultEvents();
        }
        break;

    }

  }
  getLenaValue($event) {
    const lenaVal = parseFloat($event.target.value);
    this._globalvarible.setSelectValue(lenaVal);
    if (lenaVal === 0 && this._globalvarible.getInputValue() === undefined) {
      this.totalEvents = this.cloningEvents.filter(item => item.title !== 'lenalidomida');
    } else if (this._globalvarible.getInputValue() > 0 && lenaVal === 0) {
      this.totalEvents = this.cloningEvents.filter(item => item.title !== 'lenalidomida');
    } else if (this._globalvarible.getInputValue() === 0 && lenaVal > 0) {
      this.totalEvents = this.cloningEvents.filter(item => item.title !== 'dexametasona');
    } else if (lenaVal === 0 && this._globalvarible.getInputValue() === 0) {
      this.totalEvents = this.cloningEvents.filter(item => item.title !== 'dexametasona' && item.title !== 'lenalidomida');
    } else {
      this.totalEvents = this._globalvarible.getDefaultEvents();
    }
  }
  calenderViewcreate() {
    $('.cals-parent .printable-section').each(function (index) {
      if (!$(this).find('.legends').length) {
        $(this).remove();
      }
    });

  }
  get editFormValue() { return this.Editevent.controls; }


  isEventsExists(): boolean {
    let _local_events = this._events;
    this.viewDate1 = new Date(this._pdetails['Fechaactual']);
    const view_start_date = new Date(this.viewDate1.getFullYear(), this.viewDate1.getMonth(), 1).getTime();
    const view_end_date = new Date(this.viewDate1.getFullYear(), this.viewDate1.getMonth() + 1, 0).getTime();
    const eventenddate = new Date(this.viewDate1.getFullYear(), this.viewDate1.getMonth() + 1, 0);
    _local_events = _local_events.filter((res) => {
      const event_start_date = res['start'].getTime();
      if (event_start_date >= view_start_date && event_start_date <= view_end_date) {

        return res;
      }
    });
    if (_local_events.length) {


      return true;
    } else {
      return false;
    }
  }

  predicateBy(prop) {
    return function (a, b) {
      const prd = new Date(a[prop]);
      const x = +prd;
      const nrd = new Date(b[prop]);
      const y = +nrd;
      if (x > y) {
        return 1;
      } else if (prd.getTime() < nrd.getTime()) {
        return -1;
      }
      return 0;
    };
  }


  ngAfterViewInit() {
    setTimeout(() => {
      for (const m of this.daysWithoutHoliday) {
        if (m.start.getDay() === 0 || m.start.getDay() === 6) {
          /*****block of drugs moved to weekend  */
          // this.weekendModalOpen();
          break;
        }
      }
      const firstDexa = _.filter(this._events, _.matches({ type: 'legends', title: this.drugs.dexamethasone }));
      const firstDexaStart = _.head(firstDexa);
      if (firstDexaStart) {
        firstDexaStart.color = this._colors[firstDexaStart.title].secondary;
      }

    });

    // setTimeout(() => {
    //   const firstTreatmentStart = new Date(this._localstorage.getItem('TreatmentStartDate')).getDay();
    //   if (JSON.parse(this._localstorage.getItem('DoseDivide')) && firstTreatmentStart == 5) {
    //     this.showAlertModal();
    //   }
    // });
  }


  showAlertModal() {
    this.modal.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false });
  }
  editDrugEvent(eventEdit) {
    console.log('select event', eventEdit);
    this.selectEvent = eventEdit;
    this._globalvarible.setselectedComponnet(this.selectEvent);
    this.changeEvt.emit(this.selectEvent);
    this.eventSelectedDate = this.selectEvent['start'];
    this.selecteddrugname = this.selectEvent['title'];
    this.selecteddrugcolor = this.selectEvent['color'];
    const editEvent = document.getElementById('editEvent');
    editEvent.style.display = 'block';
  }
  settingPanel() {
    this.adminstration = [
      { value: $localize`:@@Intravenosa:Intravenosa`, disp_name: $localize`:@@Intravenosa_d:Vía Intravenosa` },
      { value: $localize`:@@Subcutánea:Subcutánea`, disp_name: $localize`:@@Subcutánea_d:Vía Subcutánea` },
      { value: $localize`:@@Oral:Oral`, disp_name: $localize`:@@Oral_d:Vía Oral` }];

    let DVdString = '';
    let DVdResult = '';

    switch (this.TreatementSelection) {

      case 'DVmp':
        const DVmpString = '®';
        const DVmpResult = `Darzalex${DVmpString.sup()}`;
        const velcadeMark = 'Velcade' + DVmpString.sup();
        document.getElementById('DVmpId').innerHTML = DVmpResult;
        this.treatmentfullname = $localize`:@@treatmentDvmp:Darzalex® en combinación con Velcade® melfalán y prednisona (DVmp)`.replace(' (DVmp)', '');
        this._premedicationtext = premedication;
        this._postmedicationtext = postmedication;
        this._dosetext = profiliaxisText;
        this.treatlabels = ['Darzalex® 16 mg/kg', 'Velcade® 1.3 mg/m2', 'Melfalán 9 mg/m2', 'Prednisona 60 mg/m2'];
        this.treatoptions = ['Dose (mg)', 'Vails 20ml', 'Vails 5ml'];
        if (this.splitDoseCheck !== null) {
          this.dosage_8mg = true;
          this.treatlabels.unshift('*Darzalex® 8 mg/kg');
        }

        for (const temp of this.treatlabels) {
          if (temp === 'Darzalex® 16 mg/kg') {
            const weigthactual = this._weight * 16;
            this._dose[temp] = weigthactual.toFixed(2);
            const roundoff = Math.ceil(this._dose[temp] / 100.0) * 100;
            this._vails20ml[temp] = Math.floor(roundoff / 400).toFixed(2);
            const remaing = roundoff % 400;
            if (remaing !== 0) {
              const digitremaing = remaing / 100;
              this._vails5ml[temp] = digitremaing.toFixed(2);
            } else {
              const number = 0.00;
              this._vails5ml[temp] = number.toFixed(2);
            }
          }
          if (temp === '*Darzalex® 8 mg/kg') {
            const weigthactual = this._weight * 8;
            this._dose[temp] = weigthactual.toFixed(2);
            const roundoff = Math.ceil(this._dose[temp] / 100.0) * 100;
            this._vails20ml[temp] = Math.floor(roundoff / 400).toFixed(2);
            const remaing = roundoff % 400;
            if (remaing !== 0) {
              const digitremaing = remaing / 100;
              this._vails5ml[temp] = digitremaing.toFixed(2);
            } else {
              const number = 0.00;
              this._vails5ml[temp] = number.toFixed(2);
            }
          } else if (temp === 'Velcade® 1.3 mg/m2') {
            this._dose[temp] = (1.3 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2);
            //  1,3*0,007184*(weight^0,425)*(height^0,725m2)

          } else if (temp === 'Melfalán 9 mg/m2') {
            this._dose[temp] = (9 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2);
            //  9*0,007184*(weight^0,425)*(height^0,725m2)
          } else if (temp === 'Prednisona 60 mg/m2') {
            this._dose[temp] = (60 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2);
            //  60*0,007184*(weight^0,425)*(height^0,725m2)
            this.toggleFilterEvents = { melf: this._dose[temp], pred: this._dose[temp] };
          }

        }
        break;

      case 'DVd':
        DVdString = '®';
        DVdResult = DVdString.sup();
        document.getElementById('DVdpId').innerHTML = DVdResult;
        this.treatmentfullname = $localize`:@@treatmentDvd:'Darzalex® en combinación con Velcade® y dexametasona ' `.replace(' (DVd)', '');
        this._premedicationtext = premedication;
        this._postmedicationtext = postmedication;
        this._dosetext = profiliaxisText;
        this.treatlabels = ['Darzalex® 16 mg/kg', 'Velcade® 1.3 mg/m2', 'Dexametasona 20 mg'];
        if (this.splitDoseCheck !== null) {
          this.dosage_8mg = true;
          this.treatlabels.unshift('*Darzalex® 8 mg/kg');
        }
        for (const temp of this.treatlabels) {
          if (temp === 'Darzalex® 16 mg/kg') {
            const weigthactual = this._weight * 16;
            this._dose[temp] = weigthactual.toFixed(2);
            const roundoff = Math.ceil(this._dose[temp] / 100.0) * 100;
            this._vails20ml[temp] = Math.floor(roundoff / 400).toFixed(2);
            const remaing = roundoff % 400;
            if (remaing !== 0) {
              const digitremaing = remaing / 100;
              this._vails5ml[temp] = digitremaing.toFixed(2);
            } else {
              const number = 0.00;
              this._vails5ml[temp] = number.toFixed(2);
            }
          }
          if (temp === '*Darzalex® 8 mg/kg') {
            const weigthactual = this._weight * 8;
            this._dose[temp] = weigthactual.toFixed(2);
            const roundoff = Math.ceil(this._dose[temp] / 100.0) * 100;
            this._vails20ml[temp] = Math.floor(roundoff / 400).toFixed(2);
            const remaing = roundoff % 400;
            if (remaing !== 0) {
              const digitremaing = remaing / 100;
              this._vails5ml[temp] = digitremaing.toFixed(2);
            } else {
              const number = 0.00;
              this._vails5ml[temp] = number.toFixed(2);
            }
          } else if (temp === 'elcade® 1.3 mg/m2') {
            this._dose[temp] = (1.3 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2);
            //  1,3*0,007184*(weight^0,425)*(height^0,725m2)
          } else if (temp === 'Dexametasona 20 mg') {
            const number = 20.00;
            this._dose[temp] = number.toFixed(2);
            this.toggleFilterEvents = { dexa20: this._dose[temp] };
          }
        }
        break;
      case 'DRd':
        DVdString = '®';
        DVdResult = DVdString.sup();
        document.getElementById('DVdpId').innerHTML = DVdResult;
        this.treatmentfullname = $localize`:@@treatmentDRd:'Darzalex® en combinación con lenalidomida y dexametasona '`
          .replace(' (DRd)', '');
        this._premedicationtext = premedication;
        this._postmedicationtext = postmedication;
        this._dosetext = profiliaxisText;
        this.treatlabels = ['Darzalex® 16 mg/kg', 'Lenalidomida 25 mg', 'Dexametasona 40 mg'];
        this.treatoptions = ['Dose (mg)', 'Vails 20ml', 'Vails 5ml'];
        if (this.splitDoseCheck !== null) {
          this.dosage_8mg = true;
          this.treatlabels.unshift('*Darzalex® 8 mg/kg');
        }
        for (const temp of this.treatlabels) {
          if (temp === 'Darzalex® 16 mg/kg') {
            const weigthactual = this._weight * 16;
            this._dose[temp] = weigthactual.toFixed(2);
            const roundoff = Math.ceil(this._dose[temp] / 100.0) * 100;
            this._vails20ml[temp] = Math.floor(roundoff / 400).toFixed(2);
            const remaing = roundoff % 400;
            if (remaing !== 0) {
              const digitremaing = remaing / 100;
              this._vails5ml[temp] = digitremaing.toFixed(2);
            } else {
              const number = 0.00;
              this._vails5ml[temp] = number.toFixed(2);
            }
          }
          if (temp === '*Darzalex® 8 mg/kg') {
            const weigthactual = this._weight * 8;
            this._dose[temp] = weigthactual.toFixed(2);
            const roundoff = Math.ceil(this._dose[temp] / 100.0) * 100;
            this._vails20ml[temp] = Math.floor(roundoff / 400).toFixed(2);
            const remaing = roundoff % 400;
            if (remaing !== 0) {
              const digitremaing = remaing / 100;
              this._vails5ml[temp] = digitremaing.toFixed(2);
            } else {
              const number = 0.00;
              this._vails5ml[temp] = number.toFixed(2);
            }
          } else if (temp === 'Lenalidomida 25 mg') {
            this._dose[temp] = 25;
          } else if (temp === 'Dexametasona 40 mg') {
            const number = 40;
            this._dose[temp] = number.toFixed(2);
            this.toggleFilterEvents = { dexa40: this._dose[temp] };
          }
        }
        break;
      case 'D':
        DVdString = '®';
        DVdResult = DVdString.sup();
        document.getElementById('DVdpId').innerHTML = DVdResult;
        this.treatmentfullname = $localize`:@@treatmentD: 'Darzalex® en monoterapia ' `.replace(' (D)', '');
        this._premedicationtext = premedication;
        this._postmedicationtext = postmedication;
        this._dosetext = profiliaxisText;
        this.treatlabels = ['Darzalex® 16 mg/kg'];
        this.treatoptions = ['Dose (mg)', 'Vails 20ml', 'Vails 5ml'];

        if (this.splitDoseCheck !== null) {
          this.dosage_8mg = true;
          this.treatlabels.unshift('*Darzalex® 8 mg/kg');
        }

        for (const temp of this.treatlabels) {
          if (temp === 'Darzalex® 16 mg/kg') {
            const weigthactual = this._weight * 16;
            this._dose['Darzalex® 16 mg/kg'] = weigthactual.toFixed(2);
            const roundoff = Math.ceil(this._dose['Darzalex® 16 mg/kg'] / 100.0) * 100;
            this._vails20ml['Darzalex® 16 mg/kg'] = Math.floor(roundoff / 400).toFixed(2);
            const remaing = roundoff % 400;
            this.treatmentDCalc(remaing, temp);
            this.toggleFilterEvents = { darz: this._dose[temp] };
          }
          if (temp === '*Darzalex® 8 mg/kg') {
            const weigthactual = this._weight * 8;
            this._dose[temp] = weigthactual.toFixed(2);
            const roundoff = Math.ceil(this._dose[temp] / 100.0) * 100;
            this._vails20ml[temp] = Math.floor(roundoff / 400).toFixed(2);
            const remaing = roundoff % 400;
            this.treatmentDCalc(remaing, temp);
          }
        }
        break;

    }

  }

  treatmentDCalc(remaing, temp) {
    if (remaing !== 0) {
      const digitremaing = remaing / 100;
      this._vails5ml[temp] = digitremaing.toFixed(2);
    } else {
      const number = 0.00;
      this._vails5ml[temp] = number.toFixed(2);
    }
  }


  redirection(redirection) {
    window.open(redirection, '_blank');
  }


  maximumNumberofDays(): number {
    if (this._pdetails.Tratamientos === 'DVmp') {
      return 42;
    } else if (this._pdetails.Tratamientos === 'DVd') {
      return 21;
    } else if (this._pdetails.Tratamientos === 'DRd') {
      return 28;
    } else {
      return 28;
    }

  }


  getEndDate(TotalNumberdays): Date {
    const generateDate = momenttz(this._startDate, 'YYYY-DD-MM', true).add(TotalNumberdays, 'days').format().substring(0, 10);
    // let oneExtraMonth = momenttz(generateDate, "YYYY-DD-MM", true).add(1, 'months').format().substring(0, 10);
    return new Date(generateDate);
  }

  getNewDate(days: number): Date {
    const generateDate = momenttz(this._startDate, 'YYYY-DD-MM', true).add(days, 'days').format().substring(0, 10);
    return new Date(generateDate);
  }

  // getNumberOfMonths(startDay, diffmon) {
  //   for (let m = 0; m < diffmon; m++) {
  //     const offsetdate = moment(startDay).utcOffset();
  //     const dat = momenttz(startDay, 'YYYY-DD-MM', true).utcOffset(offsetdate)
  //       .add(m, 'months').format().substring(0, 10);
  //     this.DateArr.push((dat));
  //   }
  // }

  monthDiff() {
    const startYear = this._startDate.getFullYear();
    const endYear = this._endDate.getFullYear();
    const dates = [];

    for (let i = startYear; i <= endYear; i++) {
      const endMonth = i !== endYear ? 11 : this._endDate.getMonth();
      const startMon = i === startYear ? this._startDate.getMonth() : 0;
      for (let j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
        const month = j + 1;
        const displayMonth = month < 10 ? '0' + month : month;
        dates.push(new Date([i, displayMonth, '01'].join('-')));
      }
    }
    dates[0] = this._startDate;
    dates[dates.length - 1] = this._endDate;
    return dates;
  }

  /* delete event start   here*/
  deleteEvent() {
    this.totalEvents = this.totalEvents.filter(event => {
      if (event.type === 'legends' && event.start === this.selectEvent['start'] &&
        event.title !== '' && event.title === this.selectEvent['title']) {
        return false;
      } else {
        return true;
      }
    });

    this._globalvarible.setMyGV(' ');
    this.lastrecord = this.viewDate[this.viewDate.length - 1];
    this.viewDate.splice(this.viewDate.length - 1, 1);
    this.viewDate.push(this.lastrecord);
    this.toggle = !this.toggle;
    const editEvent = document.getElementById('editEvent');
    editEvent.style.display = 'none';
  }
  /* delete event end here*/
  /* start edit of adminstrator */
  EditEventOnCycle(callby, changeby) {
    const i = 0;
    this.totalEvents = this.totalEvents.map(item => {

      const newdata = { ...item };
      if (callby === 'To singleday') {
        if (changeby === 'color') {
          if (item.title !== '' && item.title === this.selectEvent['title'] && item.cycle === this.selectEvent['cycle']
            && item.start === this.selectEvent['start']) {
            newdata['color'] = this.changedColor1;
          }
        }
      } else if (callby === 'To the entire cycle') {
        if (item.title !== '' && item.title === this.selectEvent['title'] && item.cycle === this.selectEvent['cycle']) {
          if (changeby === 'date') {
            const myDate = new Date(newdata['start']);
            myDate.setDate(newdata['start'].getDate() + this.diffDays);
            newdata['title'] = newdata['title'] + ' ';
            newdata['start'] = myDate;
          } else if (changeby === 'color') {
            newdata['color'] = this.changedColor1;
          }
        }
      } else {
        if (changeby === 'date') {
          if (item.title !== '' && item.title === this.selectEvent['title']) {
            const myDate = new Date(newdata['start']);
            myDate.setDate(newdata['start'].getDate() + this.diffDays);
            newdata['title'] = newdata['title'] + ' ';
            newdata['start'] = myDate;
          }
        } else if (changeby === 'color') {
          if (item.title !== '' && item.title === this.selectEvent['title']) {
            newdata['color'] = this.changedColor1;
          }
        }
      }
      return newdata;
    });

  }

  editEventAdminstrator() {
    switch (this.selectEvent['title']) {
      case this.drugs.Darzalex:
        this.colorArray = [];
        this.colorArray.push(this._pdetails.Formulation === 'SC' ? this._colors.Subcutaneous.primary :
          this._colors.Intravenous.primary);
        this.changedColor1 = this.selectEvent['color'];
        break;
      case `*${this.drugs.Darzalex}`:
        this.colorArray = [];
        this.colorArray.push(this._pdetails.Formulation === 'SC' ? this._colors.Subcutaneous.primary :
          this._colors.Intravenous.primary);
        this.changedColor1 = this.selectEvent['color'];
        break;
      case this.drugs.Velcade:
        // statements1;
        this.colorArray = [];
        // this.colorArray.push("#009999");
        this.colorArray.push(this._colors.Subcutaneous.primary);
        this.changedColor1 = this.selectEvent['color'];
        break;
      case this.drugs.melphalan:
        // statements1;
        this.colorArray = [];
        this.colorArray.push('#ed7c31');
        this.changedColor1 = this.selectEvent['color'];
        break;

      case this.drugs.prednisone:
        // statements1;
        this.colorArray = [];
        this.colorArray.push('#ed7c31');
        this.changedColor1 = this.selectEvent['color'];
        break;
      case this.drugs.dexamethasone:
        this.colorArray = [];
        this.colorArray.push('#009999');
        this.colorArray.push('#ed7c31');
        this.changedColor1 = this.selectEvent['color'];
        break;
      case this.drugs.lenalidomida:
        // statements2;
        this.colorArray = [];
        this.colorArray.push('#ed7c31');
        this.changedColor1 = this.selectEvent['color'];
        break;

    }
    const editEvent = document.getElementById('editEventChoseby');
    editEvent.style.display = 'block';
  }

  // Restrict edit drag and drop
  handleRestrictEvent(eventCode, nextSameEvent): any {
    const currentDate = new Date();
    if (restriction[eventCode] && restriction[eventCode] !== undefined) {
      /**
       * priortoCurrentDateMsgDisplay
       * Prior to current date validation
       */
      if (restriction[eventCode].priortoCurrentDateValidation === true) {

        if (moment(this.Editevent.value.Fechaactual).diff(moment(currentDate), 'days') < 0) {

          if (restriction[eventCode].priortoCurrentDateMsgDisplay === true) {
            this.warningMessage = restriction[eventCode].priortoCurrentDateMsg;
            this.openModal();
          }
          return false;
        }
      }
      /**
       * prior to next event validation
       */
      if (restriction[eventCode].priortoNextEventValidation === true) {
        if (this.Editevent.value.Fechaactual > nextSameEvent.start) {

          if (restriction[eventCode].priortoNextEventMsgDislay === true) {
            this.warningMessage = restriction[eventCode].priortoNextEventMsg;
            this.openModal();

          }
          return false;
          /**
        * Display prior to next event warning
        */
        } else if (restriction[eventCode].priortoNextEventWarning === true) {

          if (moment(nextSameEvent.start).diff(moment(this.Editevent.value.Fechaactual), 'days') <= restriction[eventCode]
            .priortoNextEventWarningDays) {
            this.warningMessage = restriction[eventCode].priortoNextEventWarningMsg;
            this.openModal();
            return true;
          } else {
            return true;
          }

        }
      }

    } else {
      return true;
    }
  }

  getEventCode(event) {
    return event.title.slice(0, 4).toLowerCase();
  }

  changeColor(color) {
    this.changedColor1 = color;
  }

  openModal() {
    this.modal.open(this.warningContentModal, { centered: true, backdrop: 'static', keyboard: false });
  }
  weekendModalOpen() {
    this.modal.open(this.WeekendModal, { centered: true, backdrop: 'static', keyboard: false });
  }
  nonbussinessModal() {
    this.modal.open(this.nonbussinessday, { centered: true, backdrop: 'static', keyboard: false });
  }
  getDaysInMonth = function (month, year) {
    return new Date(year, month, 0).getDate();
  };

  eventDraggingWithModal(event, newstart) {
    const isAfterDay = momenttz(newstart).isAfter(this._startDate, 'day');
    const issameDay = momenttz(newstart).isSame(this._startDate, 'day');
    const daysInMonth = this.getDaysInMonth(this._dvmp.getEnddate().getMonth() + 1, this._dvmp.getEnddate().getFullYear());
    const endDayOfTheMonth = new Date(this._dvmp.getEnddate().setDate(daysInMonth));
    const enddate_restrict = momenttz(newstart).isAfter(endDayOfTheMonth, 'day');
    const dropDrug = _.filter(this._events, _.matches({ start: newstart, type: 'legends' }));
    if (issameDay || isAfterDay) {
      if (this.modalInstance) {
        const modelRef = this.modal.open(this.onetimeDragMsg, { centered: true, backdrop: 'static', keyboard: false });
        modelRef.result.then((data) => {
          this.draggingStatus = data;
          if (this.draggingStatus) {
            this.pdfDisclaimerText = true;
            event.start = enddate_restrict ? event.start : newstart;
            this.modalInstance = false;
            this.refresh.next();
          } else {
            this.pdfDisclaimerText = false;
            this.modalInstance = true;
          }
        });
      } else {
        event.start = enddate_restrict ? event.start : newstart;
        this.refresh.next();
      }

    }

  }

  // PopUp for delete
  deleteModal() {
    this.modal.open(this.deletingContentModal, { centered: true, backdrop: 'static', keyboard: false });
  }
  /*closing all modal start here */
  /* end edit of adminstrator */

  /* Emitted object start here*/
  public updatedevents(data: any) {
    this.selectEvent = data;
    if (data.title) {
      this.selecteddrugname = data.title;
      this.selecteddrugcolor = data.color;
    }
  }
  /* Emitted object end here*/
  /*closing all modal end here */
  close(id) {
    const modal = document.getElementById(id);


    if (this.Editevent.touched) {
      this.Editevent.reset();
    }
    modal.style.display = 'none';
  }

  inputdialog(): void {
    const dialogRef = this.dialog.open(PrePostMedicationDialogComponent, {
      disableClose: true,
      width: '450px',
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  // inputclick(){
  //   alert("click");
  // }

  inputclickAccept() {
    this.status = true;
  }

  /**Array of color scheme */
  textareaposition(event) {
    const target = event.target;
    const position = target.selectionStart;
    target.selectionEnd = position;
  }

  dialogModal(event: any, medicine, temp) {

    if (temp === 'Dexametasona 20 mg') {
      if (this.modalCount === 0) {
        this.modalCollapse = true;
        this.modalCount++;
      } else if (this.modalCount > 0) {
        this.modalCollapse = false;
      }
      if (event.target.value > 20 || event.target.value < 0 || event.target.value.length === ' ') {
        this.document.getElementById('dexametasona').innerHTML = 'Rango: [0 - 20] según Superficie Corporal';
      } else {
        this.document.getElementById('dexametasona').innerHTML = '';
      }
    }

    if (temp === 'Prednisona 60 mg/m2') {
      if (this.modalCount === 0) {
        this.modalCollapse = true;
        this.modalCount++;
      } else if (this.modalCount > 0) {
        this.modalCollapse = false;
      }
      const maxrangeVal = Number((60 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2));
      if (event.target.value > maxrangeVal || event.target.value < 0 || event.target.value.length === ' ') {
        this.document.getElementById('prednisona').innerHTML = 'Rango: [0 - ' + maxrangeVal + '] según Superficie Corporal';
      } else {
        this.document.getElementById('prednisona').innerHTML = '';
      }
    }

  }

  dialogModalLenalidomida() {
    if (this.modalCountvalcade === 0) {
      this.modalCollapse = true;
      this.modalCountvalcade++;
    } else if (this.modalCountvalcade > 0) {
      this.modalCollapse = false;
    }
  }

  dialogModalVelcade(event: any, temp) {
    if (this.modalCountvalcade === 0) {
      this.modalCollapse = true;
      this.modalCountvalcade++;
    } else if (this.modalCountvalcade > 0) {
      this.modalCollapse = false;
    }
    const minrangeVal = Number((0.7 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2));
    const maxrangeVal = Number((1.3 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2));
    if (event.target.value > maxrangeVal || event.target.value < minrangeVal || event.target.value.length === ' ') {
      this.document.getElementById('velcade').innerHTML = 'Rango: [' + minrangeVal + ' - ' + maxrangeVal + '] según Superficie Corporal';
    } else {
      this.document.getElementById('velcade').innerHTML = '';
    }
  }
  // alertMessageMelfalan;
  dialogModalMelfalan(event: any, temp) {

    if (this.modalCountMelfalan === 0) {
      this.modalCollapse = true;
      this.modalCountMelfalan++;
    } else if (this.modalCountMelfalan > 0) {
      this.modalCollapse = false;
    }
    const maxrangeVal = Number((9 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2));
    if (event.target.value > maxrangeVal || event.target.value < 0 || event.target.value.length === ' ') {
      document.getElementById('someDiv').innerHTML = 'Rango: [0 - ' + maxrangeVal + '] según Superficie Corporal';
    } else {
      this.document.getElementById('someDiv').innerHTML = '';
    }
  }

  dialogModaldexametasona(event: any, temp) {
    if (this.modalCountDexametasona === 0) {
      this.modalCollapse = true;
      this.modalCountDexametasona++;
    } else if (this.modalCountDexametasona > 0) {
      this.modalCollapse = false;
    }
    if (event.target.value > 40 || event.target.value < 0 || event.target.value.length === ' ') {
      this.document.getElementById('dexametasonaDrd').innerHTML = 'Rango: [0 - 40] según Superficie Corporal';
    } else {
      this.document.getElementById('dexametasonaDrd').innerHTML = '';
    }
  }

  onKeyMelfalan(event: any, temp) {
    if (temp === 'Melfalán 9 mg/m2') {
      const maxrangeVal = Number((9 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2));
      if (event.target.value > maxrangeVal || event.target.value < 0 || event.target.value.length === ' ') {
        document.getElementById('someDiv').innerHTML = 'Rango: [0 - ' + maxrangeVal + '] según Superficie Corporal';
      } else {
        this.document.getElementById('someDiv').innerHTML = '';
      }
    }
    if (temp === 'Prednisona 60 mg/m2') {
      const maxrangeVal = Number((60 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2));
      if (event.target.value > maxrangeVal || event.target.value < 0 || event.target.value.length === ' ') {
        this.document.getElementById('prednisona').innerHTML = 'Rango: [0 - ' + maxrangeVal + '] según Superficie Corporal';
      } else {
        this.document.getElementById('prednisona').innerHTML = '';
      }
    }
    if (temp === 'Velcade® 1.3 mg/m2') {
      const minrangeVal = Number((0.7 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2));
      const maxrangeVal = Number((1.3 * 0.007184 * (Math.pow(this._weight, 0.425)) * (Math.pow(this._height, 0.725))).toFixed(2));

      if (event.target.value > maxrangeVal || event.target.value < minrangeVal || event.target.value.length === ' ') {
        this.document.getElementById('velcade').innerHTML = 'Rango: [' + minrangeVal + ' - ' + maxrangeVal + '] según Superficie Corporal';
      } else {
        this.document.getElementById('velcade').innerHTML = '';
      }
    }
    if (temp === 'Dexametasona 20 mg') {
      if (event.target.value > 20 || event.target.value < 0 || event.target.value.length === ' ') {
        this.document.getElementById('dexametasona').innerHTML = 'Rango: [0 - 20] según Superficie Corporal';
      } else {
        this.document.getElementById('dexametasona').innerHTML = '';
      }
    }
  }


  onKeyDexa(event: any, temp) {
    this.drugChanges(event);
    if (temp === 'Dexametasona 40 mg') {
      if (event.target.value > 40 || event.target.value < 0 || event.target.value.length === ' ') {
        this.document.getElementById('dexametasonaDrd').innerHTML = 'Rango: [0 - 40] según Superficie Corporal';
      } else {
        this.document.getElementById('dexametasonaDrd').innerHTML = '';
      }
    }
  }


  dialogModalPrePost() {
    const premed = this.premedicationtext.nativeElement.value;
    if (this.prePostCount === 0) {
      this.prepostMedication = true;
      this._premedicationtext = premed;
      this.prePostCount++;
    } else if (this.prePostCount > 0) {
      this.prepostMedication = false;
      this._premedicationtext = premed;
    }
    return true;
  }

  cancelPreMedication() {
    this.cancelPreText = false;
    this.prePostCount = 0;
    this.premedicationtext.nativeElement.value = premedication;
    this._premedicationtext = this.premedicationtext.nativeElement.value;

  }

  dialogModalPrePosts() {
    if (this.prepostsCount === 0) {
      this.prepostMedication = true;
      this._postmedicationtext = this.postmedicationtext.nativeElement.value;
      this.prepostsCount++;
    } else if (this.prepostsCount > 0) {
      this.prepostMedication = false;
      this._postmedicationtext = this.postmedicationtext.nativeElement.value;
    }
  }

  cancelPostMedication() {
    this.cancelPostText = false;
    this.prepostsCount = 0;
    this.postmedicationtext.nativeElement.value = postmedication;
    this._postmedicationtext = this.postmedicationtext.nativeElement.value;

  }
  dialogModalPrePostMedication() {
    if (this.prepostMedicationCount === 0) {
      this.prepostMedication = true;
      this._dosetext = this.profiltext.nativeElement.value;
      this.prepostMedicationCount++;
    } else if (this.prepostMedicationCount > 0) {
      this.prepostMedication = false;
      this._dosetext = this.profiltext.nativeElement.value;
    }
  }

  cancelPrePostMedication() {
    this.cancelProfilText = false;
    this.prepostMedicationCount = 0;
    this.profiltext.nativeElement.value = profiliaxisText;
    this._dosetext = this.profiltext.nativeElement.value;

  }


  handleColorEvent() {

    if (this.Editevent.value.Ciclocolorcheck.trim() === 'To a single day') {

      this.EditEventOnCycle('To singleday', 'color');
      this.toggle = !this.toggle;
      this.lastrecord = this.viewDate[this.viewDate.length - 1];
      this.viewDate.splice(this.viewDate.length - 1, 1);
      this.viewDate.push(this.lastrecord);

    } else if (this.Editevent.value.Ciclocolorcheck.trim() === 'To the entire cycle') {
      this.EditEventOnCycle(this.Editevent.value.Ciclocolorcheck.trim(), 'color');
      this.toggle = !this.toggle;
      this.lastrecord = this.viewDate[this.viewDate.length - 1];
      this.viewDate.splice(this.viewDate.length - 1, 1);
      this.viewDate.push(this.lastrecord);
    } else {
      this.EditEventOnCycle(this.Editevent.value.Ciclocolorcheck.trim(), 'color');
      this.toggle = !this.toggle;
      this.lastrecord = this.viewDate[this.viewDate.length - 1];
      this.viewDate.splice(this.viewDate.length - 1, 1);
      this.viewDate.push(this.lastrecord);
    }
    this._globalvarible.setMyGV(' ');
    const editEventModal = document.getElementById('editEvent');
    const editEventChoseby = document.getElementById('editEventChoseby');

    editEventModal.style.display = 'none';
    editEventChoseby.style.display = 'none';
    this.Editevent.reset();

  }
  termsconditionclick() {
    const flaglocal = localStorage.getItem('flag');
    this._termsconditionFlag = (flaglocal === 'true');
    const modal = document.getElementById('legalDisclaimer');
    modal.style.display = 'block';
    document.getElementById('legalDisclaimerBody').scrollTop = 0;
  }

  onKeyPress(event) {
    if (event.target.value.length === 7) {
      return false;
    }
  }
  // calendar functions
  beforeMonthViewRender({ body, period, header }: { body: CalendarMonthViewDay[], period: MonthViewDay, header: WeekDay[] }): void {
    const cycle = 0;
    const l = 0;
    body.forEach(day => {
      day.events.filter((item) => {
        if (item['eventStart'] === true && item['type'] === 'cycle' && day.inMonth) {
          day.badgeTotal = item['cycle'];
        } else {
          day.badgeTotal = 0;
        }
      });
      // let cycledays = day.events.map((item) => {
      //   if (item["eventStart"] === true) {
      //     return item["type"];
      //   }
      // })

      /***old code for events cycle label */
      // console.log("cycledays==", cycledays);
      // console.log("day-events", day.events, typeof cycledays);
      // if ((cycledays.indexOf("legends")>-1) && (cycledays.indexOf("holiday")>-1)) {
      //   day.events.filter((item) => {
      //     if (item["eventStart"] === true && day.inMonth) {
      //       if (item["uuid"] !== 'holiday') {
      //         day.badgeTotal = item["cycle"];

      //       }
      //     } else {
      //       day.badgeTotal = 0;
      //     }
      //   })

      // } else if ((cycledays.indexOf("legends")>-1) && day.inMonth) {
      //   day.events.filter((item) => {
      //     if (item["eventStart"] === true) {
      //       console.log("cycle-starts",item["start"],"-",item["cycle"]);

      //       if (item["uuid"] !== 'holiday') {
      //         day.badgeTotal = item["cycle"];
      //       }
      //     } else {
      //       day.badgeTotal = 0;
      //     }
      //   })
      // } else {
      //   day.badgeTotal = 0;
      // }


    });
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    this.eventDraggingWithModal(event, newStart);
  }

  /*****commented for dragging functionality */
  /*eventTimesChanged({event, newStart,newEnd  }: CalendarEventTimesChangedEvent): void {

    let isWeekend = ((newStart.getDay() == 0 || newStart.getDay() == 6)) ? true : false;

    let isforwardDrag = momenttz(newStart).isAfter(event.start, 'day');
    let withInTreatment = momenttz(newStart).isAfter(this._startDate, 'day');
    let issameDay = momenttz(newStart).isSame(this._startDate,'day');
    let splitdose = JSON.parse(this._localstorage.getItem('DoseDivide')) ? (event['uuid']==='1Darz0') && (newStart.getDay() === 5): false;
    let splitdoseBack = JSON.parse(this._localstorage.getItem('DoseDivide')) ? (event['uuid']=== '1Darz0'
     || event['uuid']==='1Velc0') : false;

    if (isforwardDrag && !isWeekend && withInTreatment) {
      if (isforwardDrag && withInTreatment) {
       this.handleEvent(event ,newStart , splitdose);
        this.refresh.next();
      this._dvmp.getNonBussinessday() ? this.nonbussinessModal() : " ";
   } else if((withInTreatment || issameDay) && (!isWeekend)){
} else if((withInTreatment || issameDay)){
      this.backwardDrag(event, newStart, splitdoseBack);
    }
    else{
      this.refresh.next()
    }
}*/

  /*handleEvent(event: CalendarEvent, newStart,SplitCheck): void {
    let DragedEvent = Date.parse(event.start.toString());
    let differenceIndays = momenttz(newStart).diff(momenttz(event.start), 'days');
    if(SplitCheck){
      differenceIndays = differenceIndays + 3;
      this.showAlertModal();
    }
    for (let index = 0; index < this._events.length; index++) {
      let eventArray = Date.parse(this._events[index].start);
      if (eventArray >= DragedEvent && this._events[index].type == "legends") {
        let offsetday = new Date(momenttz(this._events[index].start).add(differenceIndays, "days"));
        let blockofDrug = this._events[index].block;
        if (offsetday.getDay() === 0 && blockofDrug )  {
          differenceIndays = differenceIndays + 1;
          offsetday = new Date(momenttz(offsetday).add(1, "days"));
          this._dvmp.setNonBussinessday(true);
          this._events[index].start = offsetday;
       } else if ((offsetday.getDay() === 6) && blockofDrug) {
          differenceIndays = differenceIndays + 2;
          offsetday = new Date(momenttz(offsetday).add(2, "days"));
          this._dvmp.setNonBussinessday(true);
          this._events[index].start = offsetday;
        }
        else {
          differenceIndays = differenceIndays + 0;
          this._events[index].start = newStart;
        }
      }
    }
    this.refresh.next();
    return this._events;
  }*/
  /*****end for dragging functionality */

  splitdosebackward(event, newStart) {
    const offsetday1: Date = new Date(momenttz(event.start).add(1, 'days') + '');
    const newArr = this._events.filter(events => {
      return events.type !== 'holiday' && events.start.getTime() === offsetday1.getTime();
    });
    const newArr1 = this._events.filter(eventss => {
      return eventss.type !== 'holiday' && eventss.start.getTime() === event.start.getTime();
    });

    const sliceSplitdose = [...newArr1, ...newArr];
    sliceSplitdose.forEach((item) => {
      const eventoocurance = item['uuid'].charAt(item['uuid'].length - 1);
      console.log(eventoocurance);
      if (newStart.getDay() !== 5) {
        if (eventoocurance === '0') {
          item['start'] = newStart;
        } else {
          item['start'] = new Date(momenttz(newStart).add(1, 'days') + '');
        }
      }

    });

    // }
    this.refresh.next();
    console.log('split-events', this._events);
    return this._events;
  }

  backwardDrag(event: CalendarEvent, newStart, splitdose) {

    // let uuid = event["uuid"].substring(1,4);
    const eventsByDay = this.eventOperations.getEventsbyDay(this._events, newStart);
    const eventsbyrange = this.eventOperations.geteventsByRange(this._events, event.start, newStart);
    const beforeEvents = this.eventOperations.darzalexBeforeEvents(this._events, newStart);
    const beforedarzlexevents = this.eventOperations.darzalexBeforeEvents(this._events, newStart);
    const beforevalcadeevents = this.eventOperations.valcadeBeforeEvents(this._events, newStart);
    const blockdrugs = this.eventOperations.blockofdrugs(this._events, event);

    let drugs = '';
    blockdrugs.forEach((item) => {
      drugs += item.title.substring(0, 4);
    });
    console.log('drugs-', drugs);
    if (splitdose) {
      this.splitdosebackward(event, newStart);
    } else {

      if (blockdrugs.length) {

        this.eventOperations.handleEvent(this._events,
          newStart,
          blockdrugs,
          eventsByDay,
          beforevalcadeevents,
          beforedarzlexevents,
          eventsbyrange,
          event,
          drugs.slice(0).trim(), splitdose, this._startDate);
        this.refresh.next();


      }
    }

  }



  isDraggedForward(start, end) {
    if (moment(start).diff(moment(end), 'days') > 0) {
      return false;
    } else {
      return true;
    }
  }

  open(content) {
    this.modal.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    });
  }
}
